import { useQuery } from '@tanstack/react-query';

import { QueryKey } from ':cloud/queries/types';
import { APIClientBase } from ':cloud/state/Api';
import { BaseL3Chain, GetBaseL3Response } from ':cloud/types/ts_types';

async function fetchBaseL3({ orgId, projectId }: GetBaseL3Props): Promise<BaseL3Chain[]> {
  const path = `/chain-manager/v1/organizations/${orgId}/projects/${projectId}/chains`;

  const { data } = await APIClientBase.get<GetBaseL3Response>(path);

  return data?.chains;
}

type GetBaseL3Props = {
  projectId?: string;
  orgId?: string;
};

export function useGetBaseL3({ orgId, projectId }: GetBaseL3Props) {
  const { isLoading, data, refetch } = useQuery({
    queryKey: [QueryKey.baseL3, orgId, projectId],
    queryFn: async () => fetchBaseL3({ orgId, projectId }),
    staleTime: Infinity,
    enabled: !!orgId,
    onSuccess: (chains) => {
      // Refetch if chain is pending
      if (chains?.[0]?.status === 'pending') {
        setTimeout(refetch, 3000);
      }
    },
  });

  return {
    chain: data?.[0],
    isLoading,
  };
}
